import { gql } from '@apollo/client'
import { GET_NOTIFICATIONS_DATA } from 'src/actions'
import { dispatchQueryGQL } from '../../gqlActions'
import { getTimeWithoutTimezone } from 'src/services'

const GET_NOTIFICATIONS = gql`
  query GetNotifications($dateNow: Float!) {
    getNotifications(dateNow: $dateNow) {
      backgroundColor
      creation_date
      endDate
      text
      textColor
      type
      url
    }
  }
`

export const getNotificationsGQL = () => {
  return dispatchQueryGQL({
    query: GET_NOTIFICATIONS,
    variables: { dateNow: getTimeWithoutTimezone() },
    type: GET_NOTIFICATIONS_DATA,
    key: 'getNotifications'
  })
}
